<div class="advice-wrapper" [class.advice-success]="type === 'correct'" [class.advice-error]="type === 'error'">
  <div class="advice-body">
    @if (type === 'correct') {
      <mat-icon class="advice-icon">thumb_up_alt</mat-icon>
      <p class="advice-message">¡Pesaje realizado correctamente!</p>
    } @else {
      <mat-icon class="advice-icon">warning_amber</mat-icon>
      <p class="advice-message">No se ha podido realizar el pesaje</p>
    }
  </div>
  <div class="advice-footer">
    <button mat-flat-button color="primary" class="advice-close" (click)="close()">Cerrar</button>
  </div>
</div>
